import _objectSpread from "@babel/runtime-corejs2/helpers/esm/objectSpread";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import get from 'lodash/get';
import Logger from '../logger';
export var isClientSide = function isClientSide() {
  return typeof window !== 'undefined';
};
export var isGetRequest = function isGetRequest(config) {
  return !config || !config.method || config.method && config.method.toLowerCase() === 'get';
};
/**
 *
 * This method generates endpoints url
 * @param {string} url
 * @param {Object} [config]
 * @returns {string}
 */

export var buildUrl = function buildUrl(url, config) {
  var isClient = isClientSide();
  var envPrefix = process.env.API_PREFIX || '';
  var clientPathPrefix = get(config, 'clientPathPrefix', envPrefix);
  var serverPathPrefix = get(config, 'serverPathPrefix', clientPathPrefix);
  var prefix = isClient ? clientPathPrefix : serverPathPrefix;
  return "".concat(prefix).concat(url);
};
/**
 *
 * This method calls onSuccuess method if it is provided in the config
 * @param {Object} responseData
 * @param {Object} config
 * @returns {Object}
 */

export var onSuccess = function onSuccess(responseData, config) {
  if (config.onSuccess && typeof config.onSuccess === 'function') {
    return config.onSuccess(responseData, config);
  }

  return responseData;
};
/**
 *
 * This method calls onError method if it is provided in the config
 * @param {Object} err
 * @param {Object} config
 * @returns
 */

export var onError = function onError(err, config) {
  if (config.onError && typeof config.onError === 'function') {
    return config.onError(err, config);
  }

  return err;
};
/**
 *
 * This method uses axios instance provided as a param to call axios with reqOptions
 * @param {*} axiosInstance
 * @param {Object} reqOptions
 * @returns
 */

export var callAxios =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(axiosInstance, reqOptions) {
    var startTime, response, endTime, delta;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            startTime = new Date().getTime();
            _context.next = 4;
            return axiosInstance(reqOptions);

          case 4:
            response = _context.sent;
            endTime = new Date().getTime();
            delta = endTime - startTime;

            if (delta > 500) {
              Logger.warn("Warning: ALERT: API Took more than 0.5 seconds !!! API call for: ".concat(reqOptions.url, " took : ").concat(delta, " milliseconds"));
            }

            return _context.abrupt("return", onSuccess(response, reqOptions));

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", onError(_context.t0, reqOptions));

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 11]]);
  }));

  return function callAxios(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
/**
 *
 * converts https request to http
 * @param {string} s
 */

export var http = function http(s) {
  return s.indexOf('//localhost:') > -1 ? s : s.replace('https://', 'http://');
};
/**
 *
 * fetches port from config or environemeent variable
 * @param {Object} config
 */

export var getDefaultPort = function getDefaultPort(config) {
  return config.port || process.env.API_PORT;
};
/**
 *
 * fetches host from config or environemeent variable
 * @param {Object} config
 * @returns {string} config
 */

export var getHost = function getHost(config) {
  return config.host || process.env.API_HOST || '';
};
/**
 *
 * generates baseUrl from port and host
 * @param {Object} config
 * @returns {string} url
 */

export var getBaseUrl = function getBaseUrl(config) {
  var port = getDefaultPort(config);
  var url = "".concat(getHost(config)).concat(port ? ':' : '').concat(port || '');
  return url;
};
/**
 *
 * returns protocol from baseUrl
 * @param {Object} config
 * @returns {string} protocol
 */

export var getProtocol = function getProtocol(config) {
  var baseUrl = getBaseUrl(config);
  var protocol = 'http';

  if (/https/.test(baseUrl) && config.https !== false) {
    protocol = 'https';
  }

  return protocol;
};
/**
 *
 * Returns modified headers based on configuration supplied
 * @param {Object} config
 * @param {Object} options
 * @returns {Object} header
 */

export var getHeaders = function getHeaders(config, options) {
  var overrideHeaders = config.headers;

  if (!config.overrideHeaders) {
    return _objectSpread({}, overrideHeaders, options && options.headers);
  }

  var protocol = getProtocol(config);
  var overrideProtocols = get(config, 'overrideHeaders.protocol', '');
  var overrideType = get(config, 'overrideHeaders.type', '');
  var method = get(options, 'method', 'get');
  return _objectSpread({}, overrideHeaders, overrideProtocols && overrideProtocols[protocol], overrideType && overrideType[method], options && options.headers);
};